export default __webpack_public_path__ + "static/media/718.14ddf22f.png";